import {
    Card, Grid,
    Table, TableBody, TableCell, TableHead, TableRow,
    Typography
} from '@mui/material';
import { groupDataByYearAndMonth, overallTotal } from 'app/utils/appHelpers';
import { redColor } from 'config';
import { useTemplateFontSettings } from 'styles/templateFontSettings';


function ReportBoardMemberTable({ data }) {
    
    const groupedData = groupDataByYearAndMonth(data);

    const overallTotalData = overallTotal(data);
    const allData = [];
    Object.keys(groupedData).forEach((monthKey, monthIndex) => {
        const monthData = groupedData[monthKey];

        const monthTotal = monthData.reduce((acc, curr) => {
            acc.attended += Number(curr.attendedCount) || 0;
            acc.notAttended += Number(curr.notAttendedCount) || 0;
            acc.total += Number(curr.totalMeetingCount) || 0;
            return acc;
        }, { attended: 0, notAttended: 0, total: 0 });

        monthData.forEach(item => {
            allData.push({
                type: 'data',
                monthKey,
                item,
                monthIndex
            });
        });

        allData.push({
            type: 'monthTotal',
            monthKey,
            monthTotal,
            monthIndex
        });
    });

    return (
        <>
            <Card sx={{ padding: 2, marginBottom: 3, backgroundColor: '#f8f9fa' }}>
                <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: 2, color: redColor }}>
                    Genel Toplam
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={4}>
                        <Card sx={{ padding: 2, textAlign: 'center', backgroundColor: '#e8f5e8' }}>
                            <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'success.main' }}>
                                {overallTotalData.attended}
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'success.main' }}>
                                Katıldı
                            </Typography>
                        </Card>
                    </Grid>
                    <Grid item xs={4}>
                        <Card sx={{ padding: 2, textAlign: 'center', backgroundColor: '#ffeaea' }}>
                            <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'error.main' }}>
                                {overallTotalData.notAttended}
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'error.main' }}>
                                Katılmadı
                            </Typography>
                        </Card>
                    </Grid>
                    <Grid item xs={4}>
                        <Card sx={{ padding: 2, textAlign: 'center', backgroundColor: '#e3f2fd' }}>
                            <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                                {overallTotalData.total}
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'primary.main' }}>
                                Toplam Toplantı
                            </Typography>
                        </Card>
                    </Grid>
                </Grid>
            </Card>

            <Table size="small" sx={{ marginBottom: 3, marginTop: 1, borderRadius: 3, lineHeight: 1 }}>
                <TableHead sx={{ backgroundColor: "lightgrey" }}>
                    <TableRow>
                        <TableCell align="left" sx={{  }}>Kurum</TableCell>
                        <TableCell align="left" sx={{  }}>Kurul/Kol/Komisyon Adı</TableCell>
                        <TableCell align="left" sx={{  }}>Katıldı</TableCell>
                        <TableCell align="left" sx={{  }}>Katılmadı</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {allData.map((row, index) => {
                        if (row.type === 'monthTotal') {
                            return (
                                <TableRow
                                    key={`total-${row.monthKey}`}
                                    sx={{
                                        backgroundColor: '#e0e0e0',
                                        '&:hover': { backgroundColor: '#d0d0d0' }
                                    }}
                                >
                                    <TableCell align="left" sx={{  }}></TableCell>
                                    <TableCell align="left" sx={{  }}></TableCell>
                                    <TableCell align="left" sx={{  }}></TableCell>

                                    <TableCell
                                        align="center"
                                        sx={{
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        {row.monthKey} :  {row.monthTotal.total}
                                    </TableCell>

                                </TableRow>
                            );
                        } else {
                            return (
                                <TableRow
                                    key={`data-${index}`}
                                    sx={{
                                        backgroundColor: '#fafafa',
                                        '&:hover': { backgroundColor: '#f0f0f0' }
                                    }}
                                >
                                    <TableCell align="left" sx={{  }}>{row.item.inst}</TableCell>
                                    <TableCell align="left" sx={{  }}>{row.item.unitName}</TableCell>
                                    <TableCell align="left" sx={{ color: 'success.main' }}>{row.item.attendedCount}</TableCell>
                                    <TableCell align="left" sx={{ color: 'error.main' }}>{row.item.notAttendedCount}</TableCell>
                                </TableRow>
                            );
                        }
                    })}
                </TableBody>
            </Table>
        </>
    );
}

export default ReportBoardMemberTable;
